import dayjs from 'dayjs'
import { Dispatch, useCallback, useState } from 'react'
import { getFilteredAccounts } from 'src/app/shared/services/ClientSetupService'
import { FORMAT_DATE } from '../../../../shared/constants/app.constants'

export interface IAccountTabHook {
  accountList: any
  isGettingList: boolean
  isDeleting: boolean
  setIsDeleting: (state: boolean) => void
  setAccountList: Dispatch<any>
  getAccountList: (payload: Partial<any>) => Promise<void>
}

export const useAccountTab = (): IAccountTabHook => {
  const [accountList, setAccountList] = useState<any>({
    items: [],
    total: 0,
    pageIndex: 0,
    pageSize: 10,
  })

  const [isGettingList, setIsSettingList] = useState<boolean>(false)
  const [isDeleting, setIsDeleting] = useState<boolean>(false)

  const formatClientSetupData = (data: any) => {
    return data?.map((item: any) => ({
      ...item,
      dateCreated: item?.dateCreated ? dayjs(item?.dateCreated).format(FORMAT_DATE) : '',
      archived: item?.archived ? dayjs(item?.archived).format(FORMAT_DATE) : '',
    }))
  }

  const getAccountList = useCallback(async (payload: any) => {
    try {
      setIsSettingList(true)
      const res = await getFilteredAccounts(payload)
      if (res?.data) {
        const formatData = formatClientSetupData(res.data.items)
        setAccountList({
          total: res.data.total,
          items: formatData,
        })
      }
    } catch (error) {
      console.log('ERROR: ', error)
    } finally {
      setIsSettingList(false)
    }
  }, [])

  return {
    accountList,
    isGettingList,
    isDeleting,
    setAccountList,
    getAccountList,
    setIsDeleting,
  }
}
